import React, { useEffect } from 'react';
import { useModal, UseModalResult } from '@sc1/common/hooks';
import { FullScreenModal } from '@components/FullScreenModal';
import { useLocation } from 'react-router-dom';

export const ModalContext = React.createContext<UseModalResult>({
  modal: false,
  content: null,
  open: () => null,
  close: () => null,
});

export const ModalProvider = ({ children }: { children: any }): JSX.Element => {
  const { modal, content, open, close } = useModal();
  const location = useLocation();
  useEffect(() => {
    const handleKeydown = (e) => {
      if (e.keyCode === 27) {
        close();
      }
    };
    window.addEventListener('keydown', handleKeydown);
    return () => window.removeEventListener('keydown', handleKeydown);
  }, []);

  useEffect(() => {
    // prevent scroll when modal open
    const preventDefault = (e) => e.preventDefault();

    if (!modal) {
      document.body.style.overflow = 'scroll';
      document.body.removeEventListener('touchmove', preventDefault);
    }
    if (modal) {
      document.body.style.overflow = 'hidden';
      document.body.addEventListener('touchmove', preventDefault, {
        passive: false,
      });
    }
    return () => document.body.removeEventListener('touchmove', preventDefault);
  }, [modal]);

  useEffect(() => close(), [location]); // close on page change

  return (
    <ModalContext.Provider value={{ modal, content, open, close }}>
      <FullScreenModal>{content}</FullScreenModal>
      {children}
    </ModalContext.Provider>
  );
};
